module.exports = __webpack_public_path__ + "static/img/2.0313faa8.jpg";